import React from "react";
import { formatNumberWithCommas } from "../../../../../../../Common/AllDateTimeReleventFormate";

export default function GetPricewitoutlabel({ type, price, hiring_type, price2 }) {

  return (
    <>
      $ {formatNumberWithCommas(price)}  {type == 3 && (price2 != undefined && price2 != 0) ? ` - ${formatNumberWithCommas(price2)}` : ''}
      {type == 3 && (hiring_type == 1 ? "/hour" : hiring_type == 3 ? "/weekly" : "/month")}
    </>
  );
}
